import {Inject, Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {Observable, of} from 'rxjs';
import {CORE_CONFIGURATION} from '../../core/configuration';

@Injectable({
  providedIn: 'root',
  deps: [BaseApiService]
})
export class OtpSnowApiService {
  constructor(
    private http: BaseApiService,
    @Inject(CORE_CONFIGURATION) private config
  ) {
  }

  /**
   * to verify the presence of the ContactNumber
   * username: current username.
   * searchContactFlag: If filled to "N" or "null" service doesn't call also the PICASSO.GetContactNumber
   * external service otherwise if filled to "Y" the service will call the PICASSO.GetContactNumber external service.
   */
  listWebAccount(username: string, searchContactFlag: string): Observable<any> {
    return this.http
      .get({
        path: `/CustomerManagementLegacy/v1/customerWebAccount?searchContactFlag=${searchContactFlag}&username=${username}`
      });
  }

  /**
   * to send OTP confirmation of the contactNumber
   * contactNumber: the MSISDN where the token will be sent.
   * sendResendFlag: S = Generate and send a token R = Resend an already generated.
   * action: SMS_2FA in order to send a token in the scenario 2 Factor Authentication
   * SMS_CHANGE_CN in order to send a token in the scenario Contact Number change.
   */
  createWebToken(contactNumber: string, sendResendFlag: string, action: string): Observable<any> {
    const body = {
      billingObjectIdentifier: contactNumber,
      sendResendFlag,
      action
    };

    return this.http
      .post({
        path: '/OneTimePassword/v2/createWebToken/',
        body
      });
  }

  /**
   * to set the contact number
   * username: current username.
   * contactNumber: new contact number.
   * otp: token from CreateWebToken
   */
  updateWebAccount(username: string, contactNumber: string, otp: string): Observable<any> {
    const body = {
      contactNumber,
      characteristic: [
        {
          name: 'token',
          value: otp
        }
      ]
    };

    return this.http
      .patch({
        globalErrorHandler: false,
        path: `/CustomerManagementLegacy/v1/customer/${username}`,
        body
      });
  }

  /**
   * operation invokes the validateToken operation
   * contactNumber: the MSISDN where the token will be sent.
   * otp: token from CreateWebToken.
   * action: SMS_2FA in order to send a token in the scenario 2 Factor Authentication
   * SMS_CHANGE_CN in order to send a token in the scenario Contact Number change.
   */
  checkWebToken(contactNumber: string, otp: string, action: string): Observable<any> {
    const body = {
      billingObjectIdentifier: contactNumber,
      token: otp,
      action
    };

    return this.http
      .post({
        globalErrorHandler: false,
        path: '/OneTimePassword/v2/checkWebToken',
        body
      });
  }

  keycloakSession(username: string) {
    return this.http
      .post({
        globalErrorHandler: false,
        host: this.config.apiKeycloakHost,
        path: '/auth/realms/app-br-snow/snow-session',
        body: {username}
      });
  }
}
